import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FrontEndInfo} from '../../domain/operator/frontEndInfo';
import {Observable} from 'rxjs';
import {SupportConfig} from '../../domain/operator/frontEndConfig';

@Injectable({
    providedIn: 'root'
})
export class FrontEndHttpService {
    constructor(private http: HttpClient) {}

    public findFrontInfo(thirdPartyId: string): Observable<FrontEndInfo> {
        return this.http.get<FrontEndInfo>(`/v2/front/info/${thirdPartyId}`, {});
    }

    public findSupportConfig(thirdPartyId: string): Observable<SupportConfig> {
        return this.http.get<SupportConfig>(`/front/info/${thirdPartyId}/supportConfig`);
    }
}
